import React from "react";

export const LeadInstructionsThumbnail = () => {
  return (
    <div className="lead-instructions-thumbnail">
      <div className="lead-instructions-thumbnail__copy">
        <p>Watch our MatchLeads demo</p>
      </div>
      <div
        style={{ position: "relative", paddingBottom: "56.25%", height: "0" }}
      >
        <iframe
          src="https://www.loom.com/embed/dc4a4d6c4cbb40259d58b9e4dfe532f9"
          frameBorder="0"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allowFullScreen
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
          }}
        ></iframe>
      </div>
    </div>
  );
};

export default LeadInstructionsThumbnail;
